import { render, staticRenderFns } from "./credit_quota_detail.vue?vue&type=template&id=21bac8fa&scoped=true"
import script from "./credit_quota_detail.vue?vue&type=script&lang=js"
export * from "./credit_quota_detail.vue?vue&type=script&lang=js"
import style0 from "./credit_quota_detail.vue?vue&type=style&index=0&id=21bac8fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bac8fa",
  null
  
)

export default component.exports